import { render, staticRenderFns } from "./WaitingValuesMobile.vue?vue&type=template&id=1d67d628&scoped=true&"
import script from "./WaitingValuesMobile.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesMobile.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesMobile.vue?vue&type=style&index=0&id=1d67d628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67d628",
  null
  
)

export default component.exports